<div class="dashboard-content-sec ">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="savePage()" [formGroup]="form">
        <div class="row form-section">
            <div class="col">
                <div class="card">
                    <app-breadcrumb [crumbList]="crumbList"></app-breadcrumb>

                    <div class="card-title">
                        <h5 class="fa fa-address-book">
                          {{ this.title }}
                        </h5>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>
                    </div>

                    <div class="card-form">
                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved template
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save template. Error occurred.
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <div id="template" [froalaEditor]="options" [(froalaModel)]="templateContent"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </form>
           

</div>
